export default "__VITE_ASSET__DTAQmX8b__"